import type { FC } from 'react';
import { Typography } from '@interstate/components/Typography';
import type { BusinessEntity } from '../../types/businessConversion.types';
import SearchResultRow from './SearchResultRow';

export interface BusinessResultRowProps {
    entity: BusinessEntity;
    isSelected: boolean;
    onSelect: (entity: BusinessEntity) => void;
}

const formatAddress = (address: BusinessEntity['primaryAddress']) =>
    address
        ? [address.street1, address.street2, address.city, address.stateOrProvinceAbbreviation, address.postalCode]
              .filter(Boolean)
              .join(', ')
        : '';

const BusinessResultRow: FC<BusinessResultRowProps> = ({ entity, isSelected, onSelect }) => {
    const formattedAddress = formatAddress(entity.primaryAddress);

    return (
        <SearchResultRow
            testId={`business-search-result-${entity.businessEntityId}`}
            isSelected={isSelected}
            onSelect={() => onSelect(entity)}
        >
            <Typography variant="strong-md">{entity.businessName}</Typography>
            {formattedAddress && (
                <Typography variant="body-sm" sx={{ color: '#6b7280', marginTop: '0.25rem' }}>
                    {formattedAddress}
                </Typography>
            )}
        </SearchResultRow>
    );
};

export default BusinessResultRow;
